// ===== 価格スライダー =====
(function(){

  // 価格は安い方に詰まっているので、つまみは対数目盛りにする。つまみは位置（0〜1000）だけを持ち、価格は隠し欄からフォームに送る
  // 目盛りの下端は ¥10（左端だけ ¥0＝下限なし）。最大額が小さい一覧は均等割り
  const SCALE = 1000, FLOOR = 10;
  function toPrice(pos, max){
    if(pos <= 0) return 0;
    if(pos >= SCALE) return max;
    const raw = max <= FLOOR * 2 ? pos / SCALE * max : FLOOR * Math.pow(max / FLOOR, pos / SCALE);
    const step = raw < 200 ? 10 : raw < 1000 ? 50 : raw < 5000 ? 100 : raw < 20000 ? 500 : 1000;
    return Math.min(max, Math.round(raw / step) * step);
  }
  function toPos(price, max){
    if(price <= 0 || max <= 0) return 0;
    if(price >= max) return SCALE;
    if(max <= FLOOR * 2) return Math.round(price / max * SCALE);
    return Math.max(1, Math.round(Math.log(Math.max(price, FLOOR) / FLOOR) / Math.log(max / FLOOR) * SCALE));
  }

  function getFacetForm(){
    const mobileForm = document.querySelector("#FacetFiltersFormMobile");
    const desktopForm = document.querySelector("#FacetFiltersForm");

    if (window.innerWidth < 990 && mobileForm) {
      return mobileForm;
    }

    return desktopForm || mobileForm;
  }

  function initPriceSlider(){

    const sliders = document.querySelectorAll(".price-range-slider");
    if(!sliders.length) return;

    sliders.forEach(slider => {

      if(slider.dataset.initialized) return;
      slider.dataset.initialized = "true";

      const minSlider = slider.querySelector(".slider-min");
      const maxSlider = slider.querySelector(".slider-max");
      const clearBtn = slider.querySelector(".price-clear");

      const minDisplay = slider.querySelector(".price-min");
      const maxDisplay = slider.querySelector(".price-max");
      const track = slider.querySelector(".slider-track");

      const minParam = minSlider.name || minSlider.dataset.param;
      const maxParam = maxSlider.name || maxSlider.dataset.param;
      const priceMax = parseInt(maxSlider.max,10) || 0;

      const params = new URLSearchParams(location.search);

      // URLパラメータ優先
      const urlMin = params.get(minParam);
const urlMax = params.get(maxParam);

let minVal = urlMin !== null
  ? parseInt(urlMin,10)
  : (minSlider.value ? parseInt(minSlider.value,10) : 0);

let maxVal = urlMax !== null
  ? parseInt(urlMax,10)
  : (maxSlider.value ? parseInt(maxSlider.value,10) : parseInt(maxSlider.max,10));

if(isNaN(minVal)) minVal = 0;
if(isNaN(maxVal)) maxVal = parseInt(maxSlider.max,10);

      const hiddenInput = (param) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = param;
        slider.append(input);
        return input;
      };
      const minHidden = hiddenInput(minParam);
      const maxHidden = hiddenInput(maxParam);
      [minSlider, maxSlider].forEach((range, i) => {
        range.dataset.param = i ? maxParam : minParam;
        range.removeAttribute("name");
        range.max = SCALE;
        range.step = 1;
      });
      minSlider.value = toPos(minVal, priceMax);
      maxSlider.value = toPos(maxVal, priceMax);
      // URL の価格はつまみを動かすまで丸めずに使う（目盛りの刻みに寄せると、ほかの条件を変えたときに価格の条件まで変わる）
      let exactMin = urlMin !== null ? minVal : null;
      let exactMax = urlMax !== null ? maxVal : null;

      function update(){

        // 上限を左端まで動かすと「¥0 以下」で 0 件になるので、上限は目盛りの 1 つ目（¥10）で止める
        if(parseInt(maxSlider.value,10) < 1) maxSlider.value = 1;
        if(parseInt(minSlider.value,10) > parseInt(maxSlider.value,10)){
          minSlider.value = maxSlider.value;
        }
        const max = exactMax !== null ? exactMax : toPrice(parseInt(maxSlider.value,10), priceMax);
        const min = Math.min(max, exactMin !== null ? exactMin : toPrice(parseInt(minSlider.value,10) || 0, priceMax));
        minHidden.value = min > 0 ? min : "";
        maxHidden.value = max < priceMax ? max : "";

        minDisplay.textContent = "¥" + min.toLocaleString();
        maxDisplay.textContent = "¥" + max.toLocaleString();

        const percentMin = (minSlider.value / SCALE) * 100;
        const percentMax = (maxSlider.value / SCALE) * 100;

        track.style.background =
          `linear-gradient(to right,
            #E2E8F0 ${percentMin}%,
            #FB6E00 ${percentMin}%,
            #FB6E00 ${percentMax}%,
            #E2E8F0 ${percentMax}%)`;
      }

      function applyFilter(){

  const min = minHidden.value;
  const max = maxHidden.value;

  const form = getFacetForm();
  if(!form) return;

  /* すべての price input を更新（PC + SP） */
  const minInputs = document.querySelectorAll('[name="filter.v.price.gte"]');
  const maxInputs = document.querySelectorAll('[name="filter.v.price.lte"]');

  minInputs.forEach(input=>{
    input.value = min;
  });

  maxInputs.forEach(input=>{
    input.value = max;
  });

  /* Shopify facets 更新 */
  setTimeout(()=>{
    form.dispatchEvent(new Event("input",{bubbles:true}));
  },0);

}

      function applyFilterSafe(){
        applyFilter();
      }

      // スライダー操作
      minSlider.addEventListener("input", e=>{
        e.stopPropagation();
        exactMin = null;
        update();
      });

      maxSlider.addEventListener("input", e=>{
        e.stopPropagation();
        exactMax = null;
        update();
      });

      // 確定時のみフィルター。change はマウス・指を離したときとキーボードで動かしたときに 1 回ずつ来る
      minSlider.addEventListener("change", applyFilterSafe);
      maxSlider.addEventListener("change", applyFilterSafe);

      // クリアボタン
      if(clearBtn){
        clearBtn.addEventListener("click", function(){

          minSlider.value = minSlider.min;
          maxSlider.value = maxSlider.max;
          exactMin = null;
          exactMax = null;

          update();

          const url = new URL(location.href);
          url.searchParams.delete(minParam);
          url.searchParams.delete(maxParam);

          location.href = url.toString();
        });
      }

      update();

    });

  }

  document.addEventListener("DOMContentLoaded", initPriceSlider);
  document.addEventListener("shopify:section:load", initPriceSlider);

  const facetWrapper = document.querySelector(".facets-wrapper");

  if (facetWrapper) {

    const observer = new MutationObserver(function() {
      initPriceSlider();
    });

    observer.observe(facetWrapper, {
      childList: true,
      subtree: true
    });

  }

  // モバイルフィルター開閉
  document.addEventListener("click", function(e){

    if(!e.target.closest(".mobile-facets__summary")) return;

    setTimeout(initPriceSlider,100);

  });

  // フィルター削除時
  document.addEventListener("click", function(e){

    if(!e.target.closest('.price-facet-remove, .facets__reset, .active-facets__button-remove')) return;

    const sliders = document.querySelectorAll(".price-range-slider");

    sliders.forEach(slider => {

      const minSlider = slider.querySelector(".slider-min");
      const maxSlider = slider.querySelector(".slider-max");

      minSlider.value = minSlider.min;
      maxSlider.value = maxSlider.max;

      minSlider.dispatchEvent(new Event("input",{bubbles:true}));
      maxSlider.dispatchEvent(new Event("input",{bubbles:true}));

    });

  });

  document.addEventListener("facet:updated", function(){
  initPriceSlider();
});

})();